module.exports = __webpack_public_path__ + "img/stampbenefits.791a22f1.svg";